const ROUTES = {
    LOGIN: "/login",
    FORGOT_PASSWORD: "/forgot-password",
    DASHBOARD: "/",
    ALERTS: "/alerts",
    BUILDINGS: "/buildings",
    BANKS: "/buildings/:buildingId/banks",
    DEVICES: "/buildings/:buildingId/banks/:bankId/devices",
    DEVICE_STATS: "/buildings/:building/banks/:bankId/devices/:deviceId",
    SETTINGS: "/settings",
    REPORTS: "/reports",
    PROFILE: "/profile",
    EVENTS: "/all-events",
    ALTERNATE_VIEW: "/alternate-view",
    NEW_ALTERNATE_VIEW: "/new-alternate-view"
};

export default ROUTES;
